<div class="leftMenu collapse" *ngIf="expandableMenu==false">
    <div class="leftMenu-arrow-collapse">
        <div class="expandIcon" (click)="expToCollapsable(expandableMenu)"></div>
    </div>
    <div class="expand-body">
        <ng-container *ngFor="let chart of availableCharts; let idx=index;">
            <div class="chart-item" *ngIf="chart.isAvailable"
                [ngClass]="chart.chartId === chartId ? 'chart-item-selected':'chartItem-hover'"
                [title]="chart.displayName" (click)="onChartSelect(chart)">
                <div class="chart-icon"><span
                        [ngClass]="chart.chartId === chartId ? chart.selectedImgClassName:chart.imgClassName"></span>
                </div>
                <div [ngClass]="chart.chartSelectedNumber == 0 ? 'chart-numbers DN' : 'chart-numbers'">
                    {{chart.chartSelectedNumber}}</div>
            </div>
        </ng-container>
    </div>
</div>
<div class="leftMenu expand" *ngIf="expandableMenu==true">

    <div class="leftMenu-arrow-expand">
        <div class="collapseIcon" (click)="expToCollapsable(expandableMenu)"></div>
    </div>
    <div class="expand-body">
        <ng-container *ngFor="let chart of availableCharts; let idx=index;">
            <div class="chart-item" *ngIf="chart.isAvailable"
                [ngClass]="chart.chartId === chartId ? 'chart-item-selected':'chartItem-hover'"
                (click)="onChartSelect(chart)">
                <div class="chart-icon"><span
                        [ngClass]="chart.chartId === chartId ? chart.selectedImgClassName:chart.imgClassName"></span>
                </div>
                <div [ngClass]="chart.chartSelectedNumber == 0 ? 'chart-numbers DN' : 'chart-numbers'">
                    {{chart.chartSelectedNumber}}</div>

                <div class="chart-text"
                    [ngClass]="chart.chartId === chartId ? 'chart-text-selected' :'chart-text-hover'">
                    <span class="chart-name">{{chart.displayName}}</span>
                </div>
            </div>
        </ng-container>
    </div>
</div>

<!-- {snapshot_type: 'Multiple Brands', entry_point: Array(1), dimension: Array(1)}
1
: 
{snapshot_type: 'Single Brand', entry_point: Array(1), dimension: Array(1)} -->

<div class="layout-header">
    <div class="layout-header-chart-txt" style="cursor: pointer !important;"></div>
   
    <!-- <div style="visibility:hidden;" class="layout-header-chart-arrow2">
        <div class="down-arrow"></div>
    </div>
    <div class="layout-header-chartname-txt" style="cursor: pointer !important;"></div> -->
</div>